import Grid from "@mui/material/Grid";
import DataField from "../../atoms/dataField";
import React, { FC, useState, useEffect } from "react";
import Box from "@mui/material/Box";
import { CONNECTION_TYPES } from "../../../constants/_pickerValues";
import { IFormField } from "../../shared/globalTypes";

interface Props {
  selectedConnection: string;
  onChange: React.ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement>;
  historyEndpoint: IFormField;
  historyDatabase: IFormField;
  historyUsername: IFormField;
  historyPassword: IFormField;
  historyPort: IFormField;
}

const ConnectionHistorySpoke: FC<Props> = ({
  selectedConnection,
  onChange,
  historyEndpoint,
  historyDatabase,
  historyUsername,
  historyPassword,
  historyPort,
}: Props) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    selectedConnection === CONNECTION_TYPES.hstgspoke
      ? setVisible(true)
      : setVisible(false);
  }, [selectedConnection]);

  if (visible) {
    return (
      <Box
        sx={{ border: 1, borderColor: "divider", padding: 3, width: "100%" }}
      >
        <h2>{selectedConnection}</h2>
        <Grid container spacing={4}>
          <Grid item xs={4}>
            <DataField id="383afa86-34ac-4d93-aec3-190064d7e902"
              label="Endpoint"
              name="historyEndpoint"
              type="text"
              required={true}
              onChange={onChange}
              value={historyEndpoint.fieldValue}
              error={historyEndpoint.isError}
            />
          </Grid>
          <Grid item xs={6} sx={{ display: "inline-flex" }}>
            <DataField id="6e5a18ac-8fa2-49fc-b2ba-cad30b85aa1e"
              label="Database"
              name="historyDatabase"
              type="text"
              required={true}
              onChange={onChange}
              value={historyDatabase.fieldValue}
              error={historyDatabase.isError}
            />
          </Grid>
          <Grid item xs={2}>
            <DataField id="19cb3930-f171-4e2b-a759-e3894ef9e366"
              label="Port"
              name="historyPort"
              type="number"
              required={false}
              onChange={onChange}
              value={historyPort.fieldValue}
              error={historyPort.isError}
            />
          </Grid>
          <Grid item xs={4}>
            <DataField id="98ac84f0-f30c-4f1f-93f3-776a6d7bc6cd"
              label="Username"
              name="historyUsername"
              type="text"
              required={true}
              onChange={onChange}
              value={historyUsername.fieldValue}
              error={historyUsername.isError}
            />
          </Grid>
          <Grid item xs={4}>
            <DataField id="d8635012-9915-4cb1-82b6-bb5a15d62244"
              label="Password"
              name="historyPassword"
              type='password'              
              required={true}
              onChange={onChange}
              value={historyPassword.fieldValue}
              error={historyPassword.isError}
            />
          </Grid>
        </Grid>
      </Box>
    );
  } else {
    return <></>;
  }
};

export default ConnectionHistorySpoke;
